
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".5","y":".5","width":"15","height":"15","rx":"7.5","fill":"#0050EC","fill-opacity":".05"}}),_c('rect',{attrs:{"x":".5","y":".5","width":"15","height":"15","rx":"7.5","stroke":"#0078E6"}}),_c('path',{attrs:{"d":"M7.078 9.187v-.102c.003-.471.047-.846.133-1.125.088-.279.213-.503.375-.672a2.88 2.88 0 01.59-.473c.159-.099.3-.207.426-.324a1.41 1.41 0 00.3-.398 1.11 1.11 0 00.11-.496.974.974 0 00-.145-.535.98.98 0 00-.39-.352 1.166 1.166 0 00-.543-.125c-.185 0-.361.04-.528.121-.164.078-.3.198-.41.36a1.18 1.18 0 00-.18.605h-1.39c.013-.495.133-.909.36-1.242.228-.334.53-.584.905-.75.378-.167.795-.25 1.25-.25.498 0 .935.087 1.313.261.38.175.676.424.887.747.213.32.32.7.32 1.14 0 .297-.048.563-.145.797a1.935 1.935 0 01-.402.625 2.944 2.944 0 01-.621.488 2.65 2.65 0 00-.52.407 1.35 1.35 0 00-.296.496c-.063.187-.095.419-.098.695v.102h-1.3zm.68 2.437a.833.833 0 01-.606-.25.823.823 0 01-.254-.61c0-.234.085-.434.254-.6a.833.833 0 01.606-.25c.232 0 .432.082.601.25a.808.808 0 01.258.6c0 .16-.04.304-.12.434a.897.897 0 01-.313.313.82.82 0 01-.426.113z","fill":"#0078E6"}})])
          )
        }
      }
    